import { Button, Paper, Typography, Grid, MenuItem, Select, FormControl, InputLabel, Snackbar, Alert } from '@mui/material';
import { useForm, FormProvider, Controller } from 'react-hook-form'; // Use Controller to bind form fields
import { TextField } from '../../components';  // Assuming TextField is a custom component
import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL, toast } from '../../utils';
import moment from "moment";
import { useNavigate } from 'react-router-dom';

export const LicenceRegistration = () => {
     const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [macAddress, setMacAddress] = useState(null);
    const [apiData, setApiData] = useState(null);
    const [error, setError] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false); // State for Snackbar visibility

    const methods = useForm({
        mode: 'onBlur', // You can change the mode to 'onSubmit' or 'onChange' if preferred
    });

    const createLicenseRegistration = async (data) => {
        const currentDate = moment();
        const expireDate = moment(data.expireDate);
        const daysDifference = expireDate.diff(currentDate, "days");
        try {
            setLoading(true);
            console.log(data);
            const registrationData = {
                ...data, mac_address: macAddress, expireDate:`${daysDifference}d`
            };
            const response = await axios.post(`https://hms-admin-panel.vercel.app/api/admin-user`, registrationData);
            setApiData(response.data);
            toast('Licence Created Successfully!', { variant: 'success' });
            navigate('/activation'); 
        } catch (error) {
            console.error('Error creating license registration:', error);
            setError('Error creating license registration.');
            toast('License not Created!', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchMacAddress = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${BASE_URL}/mac-address`);
                setMacAddress(response.data.macAddress);
            } catch (error) {
                console.error('Error fetching MAC address:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchMacAddress();
    }, []);

    return (
        <Paper
            sx={{
                width: 'clamp(80rem, 80%, 80rem)',
                mx: 'auto',
                my: 7,
                p: 3,
                backgroundColor: 'white',
                backdropFilter: 'blur(5rem)',
                borderRadius: '1.5rem',
                height: '45rem',
            }}
        >
            <Typography variant="h3" gutterBottom color="#1976d2" textAlign="center" style={{ fontWeight: 'bold' }}>
                License Registration
            </Typography>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(createLicenseRegistration)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="nameOfOrg"
                                label="Enter Organization Name"
                                placeholder="Enter Organization Name"
                                fullWidth
                                required
                                error={!!methods.formState.errors.nameOfOrg}
                                helperText={methods.formState.errors.nameOfOrg ? 'Organization Name is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {/* Use Select component here */}
                            <FormControl fullWidth required error={!!methods.formState.errors.typeOfOrg}>
                                <InputLabel>Select Type Of Organization</InputLabel>
                                <Controller
                                    name="typeOfOrg"
                                    control={methods.control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            label="Select Type Of Organization"
                                            sx={{

                                                borderRadius: '8px', // Rounded corners
                                                '& .MuiSelect-icon': {
                                                    color: '#1976d2', // Customize the dropdown icon color
                                                },
                                                '& .MuiInputBase-root': {
                                                    paddingRight: '30px', // Adjust padding for icon
                                                    height: '36px', // Set height of the input
                                                    fontSize: '14px', // Adjust font size
                                                },
                                                '& .MuiInputBase-input': {
                                                    paddingTop: '8px', // Adjust vertical padding
                                                    paddingBottom: '8px', // Adjust vertical padding
                                                }
                                            }}

                                        >
                                            <MenuItem value="">Select Type Of Organization</MenuItem>
                                            <MenuItem value="group">Group</MenuItem>
                                            <MenuItem value="hospital">Hospital</MenuItem>
                                            <MenuItem value="pharmacy">Pharmacy</MenuItem>
                                            <MenuItem value="lab">Lab</MenuItem>
                                        </Select>
                                    )}
                                />
                                {methods.formState.errors.typeOfOrg && (
                                    <div style={{ color: 'red', fontSize: '0.75rem' }}>
                                        Type of Organization is required
                                    </div>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="emailOfOrg"
                                label="Enter Organization Email"
                                placeholder="Enter Organization Email"
                                fullWidth
                                required
                                error={!!methods.formState.errors.emailOfOrg}
                                helperText={methods.formState.errors.emailOfOrg ? 'Organization Email is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="password"
                                label="Enter Organization Password"
                                placeholder="Enter Organization Password"
                                type="password"
                                fullWidth
                                required
                                error={!!methods.formState.errors.password}
                                helperText={methods.formState.errors.password ? 'Password is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="phoneOfOrg"
                                label="Enter Organization Phone"
                                placeholder="Enter Organization Phone"
                                fullWidth
                                required
                                error={!!methods.formState.errors.phoneOfOrg}
                                helperText={methods.formState.errors.phoneOfOrg ? 'Phone number is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="addressOfOrg"
                                label="Enter Organization Address"
                                placeholder="Enter Organization Address"
                                fullWidth
                                required
                                error={!!methods.formState.errors.addressOfOrg}
                                helperText={methods.formState.errors.addressOfOrg ? 'Address is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="cityOfOrg"
                                label="Enter City"
                                placeholder="Enter City"
                                fullWidth
                                required
                                error={!!methods.formState.errors.cityOfOrg}
                                helperText={methods.formState.errors.cityOfOrg ? 'City is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="stateOfOrg"
                                label="Enter State"
                                placeholder="Enter State"
                                fullWidth
                                required
                                error={!!methods.formState.errors.stateOfOrg}
                                helperText={methods.formState.errors.stateOfOrg ? 'State is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="pincodeOfOrg"
                                label="Enter Pincode"
                                placeholder="Enter Pincode"
                                fullWidth
                                required
                                error={!!methods.formState.errors.pincodeOfOrg}
                                helperText={methods.formState.errors.pincodeOfOrg ? 'Pincode is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="nameOfadminOfOrg"
                                label="Enter Admin Name"
                                placeholder="Enter Admin Name"
                                fullWidth
                                required
                                error={!!methods.formState.errors.nameOfadminOfOrg}
                                helperText={methods.formState.errors.nameOfadminOfOrg ? 'Admin Name is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="emailOfAdmin"
                                label="Enter Admin Email"
                                placeholder="Enter Admin Email"
                                fullWidth
                                required
                                error={!!methods.formState.errors.emailOfAdmin}
                                helperText={methods.formState.errors.emailOfAdmin ? 'Admin Email is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="phoneOfAdmin"
                                label="Enter Admin Phone"
                                placeholder="Enter Admin Phone"
                                fullWidth
                                required
                                error={!!methods.formState.errors.phoneOfAdmin}
                                helperText={methods.formState.errors.phoneOfAdmin ? 'Admin Phone is required' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="expireDate"
                                placeholder="Enter Expiry Date"
                                type="date"
                                fullWidth
                                required
                                error={!!methods.formState.errors.expireDate}
                                helperText={methods.formState.errors.expireDate ? 'Expiry Date is required' : ''}
                            />
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                sx={{ mt: 3 }}
                                variant="contained"
                                color="primary"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? 'Submitting...' : 'Submit'}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </FormProvider>
        </Paper>
    );
};
